<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline">{{ $t('investorAdd.title') }}</h1>
          <hr />
          <investor-form />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import InvestorForm from '@/components/investor/InvestorForm.vue';
import hasPermission from '@/helpers/hasPermission';

export default {
  beforeRouteEnter(to, from, next) {
    if (hasPermission('investor_add')) next();
    if (from.name !== 'investors-list') next({ name: 'investors-list' });
  },
  name: 'AddInvestorPage',
  components: {
    InvestorForm,
  },
  data() {
    return {};
  },
  computed: {},
};
</script>

<style lang="scss" scoped></style>
